export { default } from "./innerPanel";
